import { render, staticRenderFns } from "./couponsList.vue?vue&type=template&id=223f2656&scoped=true&"
import script from "./couponsList.vue?vue&type=script&lang=js&"
export * from "./couponsList.vue?vue&type=script&lang=js&"
import style0 from "./couponsList.vue?vue&type=style&index=0&id=223f2656&lang=scss&scoped=true&"
import style1 from "./couponsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f2656",
  null
  
)

export default component.exports